/*global google*/
import DMVOfficesMap from '../services/DMVOfficesMap';
import _ from 'lodash';

export default {
  init() {
    const OfficesMap = new DMVOfficesMap;
    OfficesMap.render();

    const map = OfficesMap.getMap();
    const markers = OfficesMap.getMarkers();
    const infoWindow = new google.maps.InfoWindow({
      maxWidth: 300,
    });

    const officeElements = document.querySelectorAll('[data-href]');

    officeElements.forEach(el => {
      el.addEventListener('mouseenter', _.debounce(function () {
        const office = markers.find(item => {
          return item.id == el.dataset.id;
        });
        infoWindow.setContent(office.infoWindowContent);
        infoWindow.open(map, office);
      }, 400));

      el.addEventListener('click', () => {
        window.location.pathname = el.dataset.href;
      });
    });

    window.addEventListener('scroll', _.throttle(function () {
      const map = document.querySelector('#map');

      if (window.scrollY > 186 /* Self picked value */) {
        map.classList.add('sticky-map');
      } else {
        map.classList.remove('sticky-map');
      }
    }, 300));
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-city.js